"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const utilities_1 = require("../../Themes/utilities");
const polished_1 = require("polished");
const Icon_1 = tslib_1.__importDefault(require("../../Icon"));
const react_1 = tslib_1.__importDefault(require("react"));
const StatusBar_1 = tslib_1.__importDefault(require("../StatusBar"));
const styled_components_1 = tslib_1.__importStar(require("../../Themes/styled-components"));
const ResponsiveLabel = styled_components_1.default.div `
  display: none;
  ${(0, utilities_1.mb)('l')} {
    display: block;
    margin-left: ${(0, polished_1.rem)(12)};
  }
`;
const StatusBarCloseButton = ({ onClose, theme }) => {
    return (react_1.default.createElement(StatusBar_1.default.Button, { onClick: onClose },
        react_1.default.createElement(Icon_1.default, { name: "close", size: "l", color: theme.color.primary }),
        react_1.default.createElement(ResponsiveLabel, null, "Ukon\u010Di\u0165")));
};
exports.default = react_1.default.memo((0, styled_components_1.withTheme)(StatusBarCloseButton));
